let env = {
    http: ''
}

export const config = (key) => {
    let value = env[key];
    if (value !== undefined) {
        return value
    }
}